/* global fetchProcurementStatsUrl approvalsSummaryUrl authUserId eventSlug fetchHighPriorityProcurementsUrl fetchUrl fetchProcurementKanbanBoardDataUrl purchaseRequisitionsExportUrl purchaseOrdersExportUrl */
/* global indexUrlOpened indexUrlApproved indexUrlRejected indexUrlCancelled updateUrl deleteUrl toggleUrl createPurchaseOrderUrl */
/* global fetchProcurementPlanItemUrl listUsersUrl downloadProcurementPlanItemAttachmentUrl */
/* global indexPOUrl updatePOUrl deletePOUrl cancelPOUrl togglePOUrl indexPOUrlApproved indexPOUrlRejected indexPOUrlCanceled */
/* global policiesIndexUrl policiesCreateUrl policiesUpdateUrl policiesDeleteUrl */
/* global categoriesIndexUrl categoriesUpdateUrl categoriesCreateUrl categoriesDeleteUrl */
/* global supplierContractsTermOverduesIndexUrl fetchContractStatsUrl fetchContractDashboardUrl updateContractEndingSoonWindowUrl updateSignedContractUrl toggleErpUrl syncNowUrl syncProcurementPlanProjectsUrl fetchDepartmentsUrl storeProcurementPlanItemUrl */
/* global refreshCommitmentDataUrl directPurchaseOrderUrl storePRUrl indexPRUrl expensesUrl directCommitmentUrl workforceContractBulkDeleteUrl revenueContractBulkDeleteUrl */
/* global draftsIndexUrl deleteDraftUrl */
/* global isProcurementPlanModuleEnabled isReportPurchaseOrdersModuleEnabled isWorkforceModuleEnabled isSupplierPortalEnabled */
/* global isProcurementRedesignEnabled currencySymbol fetchProcurementPlanItemsUrl */
/* global groups users departments prEnabled eaEnabled directCommitEnabled */
/* global approvalStatuses pendingStatus cancelledStatus approvalPOStatuses pendingPOStatus */
/* global integrationConfigured syncEnabled action model activeTabId */
/* global eventStartDate eventEndDate departmentsOptions revDepartmentsOptions ownersOptions openRecord */

import React, { useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import { useProcurement } from './context/ProcurementContext';
import ProcurementProvider from './context/ProcurementProvider';
import ApprovalsDetailModal from './face/ApprovalsDetailModal';
import { RECORD_TYPES } from './face/approvalsHelpers';
import ProcurementFace from './face/ProcurementFace';
import ProcurementContractManagementTab from './ProcurementContractManagementTab';
import ProcurementTab from './ProcurementTab';
import { TOP_TABS } from './procurementTabs';

import Tabs, { RenderStrategyOnFirstVisit } from 'CommonComponents/Tabs';

import { ConfirmationModalProvider } from 'Context/ConfirmationModalContext';
import { UsersProvider } from 'Context/UsersContext';

/** The server's lowercase record kinds, mapped onto the drawer's record types. */
const OPEN_RECORD_TYPES = { ea: RECORD_TYPES.EA, dc: RECORD_TYPES.DC, pr: RECORD_TYPES.PR };

/**
 * The record a `?purchase_order=` / `?purchase_requisition=` link asked for, in the row shape the
 * details drawer reads. An unavailable record keeps the flag and nothing else.
 */
const openRecordRow = (record) => {
    if (!record) {
        return null;
    }

    if (record.unavailable) {
        return { unavailable: true };
    }

    return { type: OPEN_RECORD_TYPES[record.type], reference: record.reference, detailUrl: record.detailUrl };
};

function ProcurementIndex() {
    const { settings } = useProcurement();

    // `activeTabId` names a NESTED tab (e.g. `procurement---approvals`); this bar only holds the
    // two top-level ids, and a controlled id matching neither renders no panel at all.
    const [activeTab, setActiveTab] = useState(
        settings.activeTabId?.startsWith(TOP_TABS.CONTRACT_MANAGEMENT) ? TOP_TABS.CONTRACT_MANAGEMENT : TOP_TABS.PROCUREMENT,
    );

    // Rendered outside the tabs so it opens over whichever Procurement view the flag selects.
    const [linkedRecord] = useState(() => openRecordRow(settings.openRecord));
    const [linkedRecordOpen, setLinkedRecordOpen] = useState(!!linkedRecord);

    const tabs = [
        {
            id: TOP_TABS.PROCUREMENT,
            title: $t('Procurement'),
            content: () => (settings.isProcurementRedesignEnabled ? <ProcurementFace /> : <ProcurementTab />),
            active: settings.activeTabId?.startsWith(TOP_TABS.PROCUREMENT),
        },
        {
            id: TOP_TABS.CONTRACT_MANAGEMENT,
            title: $t('Contract Management'),
            content: () => <ProcurementContractManagementTab />,
            active: settings.activeTabId?.startsWith(TOP_TABS.CONTRACT_MANAGEMENT),
        },
    ];

    return (
        <div className="tw-flex tw-flex-col tw-gap-6">
            <Tabs tabs={tabs} activeTab={activeTab} onTabActivate={setActiveTab} renderStrategy={RenderStrategyOnFirstVisit} />
            {linkedRecord && (
                <ApprovalsDetailModal
                    row={linkedRecord}
                    isOpen={linkedRecordOpen}
                    onClose={() => setLinkedRecordOpen(false)}
                    currencySymbol={settings.currencySymbol}
                />
            )}
        </div>
    );
}

if (document.getElementById('ProcurementIndex')) {
    var root = document.getElementById('ProcurementIndex');

    ReactDOM.render(
        <App>
            <ConfirmationModalProvider>
                <UsersProvider fetchUrl={listUsersUrl}>
                    <ProcurementProvider
                        // settings
                        groups={groups}
                        users={users}
                        departments={departments}
                        isPrEnabled={prEnabled}
                        isEaEnabled={eaEnabled}
                        isDirectCommitEnabled={directCommitEnabled}
                        isProcurementPlanModuleEnabled={isProcurementPlanModuleEnabled}
                        isReportPurchaseOrdersModuleEnabled={isReportPurchaseOrdersModuleEnabled}
                        isWorkforceModuleEnabled={isWorkforceModuleEnabled}
                        isSupplierPortalEnabled={isSupplierPortalEnabled}
                        isProcurementRedesignEnabled={isProcurementRedesignEnabled}
                        currencySymbol={currencySymbol}
                        isIntegrationConfigured={integrationConfigured}
                        isSyncEnabled={syncEnabled}
                        processedActionSyncSuppliers={action}
                        processedModelSupplier={model}
                        approvalStatuses={approvalStatuses}
                        pendingStatus={pendingStatus}
                        cancelledStatus={cancelledStatus}
                        approvalPOStatuses={approvalPOStatuses}
                        pendingPOStatus={pendingPOStatus}
                        activeTabId={activeTabId}
                        openRecord={openRecord}
                        eventStartDate={eventStartDate}
                        eventEndDate={eventEndDate}
                        departmentsOptions={departmentsOptions}
                        revDepartmentsOptions={revDepartmentsOptions}
                        ownersOptions={ownersOptions}
                        authUserId={authUserId}
                        eventSlug={eventSlug}
                        // Routes
                        fetchProcurementStatsUrl={fetchProcurementStatsUrl}
                        approvalsSummaryUrl={approvalsSummaryUrl}
                        fetchHighPriorityProcurementsUrl={fetchHighPriorityProcurementsUrl}
                        fetchProcurementPlanUrl={fetchUrl}
                        fetchProcurementPlanItemUrl={fetchProcurementPlanItemUrl}
                        fetchProcurementPlanItemsUrl={fetchProcurementPlanItemsUrl}
                        downloadProcurementPlanItemAttachmentUrl={downloadProcurementPlanItemAttachmentUrl}
                        fetchProcurementKanbanBoardDataUrl={fetchProcurementKanbanBoardDataUrl}
                        purchaseRequisitionsExportUrl={purchaseRequisitionsExportUrl}
                        fetchOpenedPurchaseRequisitions={indexUrlOpened}
                        fetchApprovedPurchaseRequisitions={indexUrlApproved}
                        fetchRejectedPurchaseRequisitions={indexUrlRejected}
                        fetchCancelledPurchaseRequisitions={indexUrlCancelled}
                        updatePurchaseRequisitionUrl={updateUrl}
                        deletePurchaseRequisitionUrl={deleteUrl}
                        togglePurchaseRequisitionUrl={toggleUrl}
                        createPurchaseOrderUrl={createPurchaseOrderUrl}
                        purchaseOrdersExportUrl={purchaseOrdersExportUrl}
                        fetchPurchaseOrderUrl={indexPOUrl}
                        updatePurchaseOrderUrl={updatePOUrl}
                        deletePurchaseOrderUrl={deletePOUrl}
                        cancelPurchaseOrderUrl={cancelPOUrl}
                        togglePurchaseOrderUrl={togglePOUrl}
                        fetchApprovedPurchaseOrdersUrl={indexPOUrlApproved}
                        fetchRejectedPurchaseOrdersUrl={indexPOUrlRejected}
                        fetchCanceledPurchaseOrdersUrl={indexPOUrlCanceled}
                        fetchPoliciesUrl={policiesIndexUrl}
                        createPolicyUrl={policiesCreateUrl}
                        updatePolicyUrl={policiesUpdateUrl}
                        deletePolicyUrl={policiesDeleteUrl}
                        fetchCategoriesUrl={categoriesIndexUrl}
                        updateCategoryUrl={categoriesUpdateUrl}
                        createCategoryUrl={categoriesCreateUrl}
                        deleteCategoryUrl={categoriesDeleteUrl}
                        fetchSupplierContractsTermOverduesIndexUrl={supplierContractsTermOverduesIndexUrl}
                        fetchContractStatsUrl={fetchContractStatsUrl}
                        fetchContractDashboardUrl={fetchContractDashboardUrl}
                        updateContractEndingSoonWindowUrl={updateContractEndingSoonWindowUrl}
                        updateSignedContractUrl={updateSignedContractUrl}
                        toggleSyncErpUrl={toggleErpUrl}
                        syncErpNowUrl={syncNowUrl}
                        listUsersUrl={listUsersUrl}
                        syncProcurementPlanProjectsUrl={syncProcurementPlanProjectsUrl}
                        fetchDepartmentsUrl={fetchDepartmentsUrl}
                        storeProcurementPlanItemUrl={storeProcurementPlanItemUrl}
                        refreshCommitmentDataUrl={refreshCommitmentDataUrl}
                        directPurchaseOrderUrl={directPurchaseOrderUrl}
                        storePRUrl={storePRUrl}
                        indexPRUrl={indexPRUrl}
                        fetchExpensesUrl={expensesUrl}
                        directCommitmentUrl={directCommitmentUrl}
                        draftsIndexUrl={draftsIndexUrl}
                        deleteDraftUrl={deleteDraftUrl}
                        workforceContractBulkDeleteUrl={workforceContractBulkDeleteUrl}
                        revenueContractBulkDeleteUrl={revenueContractBulkDeleteUrl}
                    >
                        <ProcurementIndex />
                    </ProcurementProvider>
                </UsersProvider>
            </ConfirmationModalProvider>
        </App>,
        root,
    );
}
